import React ,{useState , useEffect} from 'react';
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import { useStripe } from '@stripe/react-stripe-js';
import { useTranslation } from "react-i18next";
import Styles from "../../scss/subscriptions.module.scss";
import { InvoicingTransactionFee } from "./InvoicingTransactionFee";
import {useSubscription} from "../../hooks/useSubscription";
import { Notification } from "./ui/Notification";
import { useSnackbarMessages } from "../../yoello-lib/modules/components/snackbar/SnackbarContext";

export function InvoicingContainer() {
  const [isLoading, setIsloading] = useState<boolean>(false);
  const [state, setState] = useState<{stage:number,url?:string|null,customerId?:string|null}>({stage:0,url:null,customerId:null});
  const [subscriptionStatus, setSubscriptionStatus] = useState<string|null>(null);
  const stripe = useStripe();
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const {selectedVenueId} = useSubscription();
  const { callAPI:invoicingCall} = useAPIV2<any>(APIExtensions.invoicing, { onMountDisabled: true });
  const { callAPI:integrationSubscriptionsCall} = useAPIV2<any>(APIExtensions.subscriptions, { onMountDisabled: true });
  const { t } = useTranslation();
  useEffect(() => {
    const fetchSubscriptionData = async()=>{
      try{
        setIsloading(true);
        const {data,isSuccessful} = await integrationSubscriptionsCall(HTTPMethods.GET,{
          params:{
            venue_id:selectedVenueId
          }
        })
        if(isSuccessful && data?.length>0){
           setState({stage:1,customerId:data[0].customer_id})
           if(data[0].subscription_status === "ERROR"){
              setSubscriptionStatus("Error")
            }
          setIsloading(false);
        }else{
          setIsloading(false);
        }
      }catch(error){
        setIsloading(false);
        sendSnackbarMessage(t("subscription.barclaycard.notifications.subscriptionRequestFailed"), "error");
      } 
    }
    fetchSubscriptionData();
  // eslint-disable-next-line
  }, [])
  useEffect(() => {
   if(state.customerId){
    const fetchPortalUrl = async()=>{
      try{
        setIsloading(true);
        const {data,isSuccessful} = await invoicingCall(HTTPMethods.POST,{
          query:"customer_portal_session",
          body:{
            customer_id:state.customerId,
            venue_id:selectedVenueId
          }
        })
        if(isSuccessful && data){
           setState({stage:1,url:data.portal_url});
           setIsloading(false);
        }
      }catch(error){
        setIsloading(false);
        sendSnackbarMessage(t("subscription.barclaycard.notifications.portalURLFailed"), "error");
      } 
    }
    fetchPortalUrl();
   }
  // eslint-disable-next-line
  }, [state.customerId])
  async function setUpInvoicingPayment(){
      setIsloading(true);
      const { data, isSuccessful } = await invoicingCall(HTTPMethods.POST,{
        query:"checkout_session",
        body:{
          venue_id:selectedVenueId
        }
      });
        if (isSuccessful && data){
          stripe?.redirectToCheckout({
            sessionId: data.session_id
        });
      }
  }
  if(!stripe)
  {
    return <div>{t("subscription.barclaycard.notifications.StripeError")}</div>
  }
  return (
      <div className={Styles.SubscriptionsContainer}>  
            {subscriptionStatus && <Notification message={t(`subscription.barclaycard.notifications.${subscriptionStatus}`)} type={subscriptionStatus} />}
            <InvoicingTransactionFee 
                onClick={setUpInvoicingPayment} 
                loading={isLoading}
                state={state}
            />
      </div>
  )
}

